import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';

@model.cacheDuration()
@model.urnResource('plan_analysis_status')
@doc.path('/plan_analysis_statuses/{?id}')
export default class PlanAnalysisStatusModel extends MapServiceModel {
	private declare _tsFilters: {
		'reference': Map_PlanAnalysisStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
		'reference': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Map_PlanAnalysisStatusReference;
}
